import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const ChangeInventoryApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "ChangeInventory" */ "./ChangeInventoryApp");
    return { default: namedExport.ChangeInventoryApp };
});

export const ChangeInventory: TeamAppConfig = {
    title: "ChangeInventory",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "ChangeInventory",
    team: "ECSAndDeployment",
    publicId: "Exchange\\Change Management",
    owner: "ecs-support@microsoft.com",
    role: "*",
    tags: ["Change", "ECS", "Deployment", "Incident"],
    app: ChangeInventoryApp,
    path: "/ChangeInventory"
};
